import * as React from 'react';
export const IcGlassBreakSensor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 8.99h-6l2 3-2 3 2 3-1.33 2H18c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zM12 11.99l-2-3H6c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h4.67l1.33-2-2-3 2-3zM18.85 4.87c-.06-.12-.14-.23-.24-.32A10.004 10.004 0 0011.94 2c-2.46 0-4.84.91-6.67 2.55a.987.987 0 00-.07 1.41.987.987 0 001.41.07A7.996 7.996 0 0111.94 4c1.97 0 3.86.72 5.33 2.03.18.16.42.25.67.25a.976.976 0 00.74-.3c.09-.1.16-.21.21-.34.05-.13.07-.26.06-.4 0-.13-.04-.27-.1-.39v.02z'
      fill='currentColor'
    />
    <path
      d='M11.93 5.01c-1.3 0-2.57.42-3.61 1.21-.1.08-.19.18-.26.29-.07.11-.11.24-.13.37-.02.13 0 .26.03.39s.09.25.17.35a.978.978 0 001.05.35.88.88 0 00.35-.17 4.03 4.03 0 012.39-.79c.86 0 1.7.28 2.39.79.21.16.48.23.74.2s.5-.17.66-.38c.16-.21.23-.48.2-.74a.978.978 0 00-.38-.66 6.031 6.031 0 00-3.61-1.21h.01z'
      fill='currentColor'
    />
  </svg>
);
